import {Component, OnInit} from '@angular/core';
import {RegistryService} from "../../../../services/registry.service";
import {CartService} from "../../../../services/cart.service";
import {Cart} from "../../../../models/CartModels/cart";

import {CartItem} from "../../../../models/CartModels/cartItem";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../../../../services/auth.service";
import {Customer} from "../../../../models/CustomerInfo/Customer";
import {MatSnackBar} from '@angular/material/snack-bar';
import {GoogleAnalyticsService} from "../../../../services/google-analytics.service";

@Component({
    selector: 'app-login-icon',
    templateUrl: './login-icon.component.html',
    styleUrls: ['./login-icon.component.css']
})
export class LoginIconComponent implements OnInit {

    customer_type = '';
    products_count = 0;
    cart: Cart;
    baseImageUrl;
    status = null;
    customer: Customer;
    isLoggin = false;
    isLogginout = false;

    loginForm = new FormGroup({

        login_email: new FormControl('', Validators.required),
        login_password: new FormControl('', Validators.required),
    });

    userLoggedEvent;
    customerLoadedEvent;

    constructor(private authService: AuthService,
                private googleService: GoogleAnalyticsService,
                private registry: RegistryService, private snackBar: MatSnackBar, private cartService: CartService) {


        this.userLoggedEvent = this.authService.UserLoggedInEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;

        });

        this.customerLoadedEvent = this.registry.CustomerLoadedEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;

        });


        this.loginForm.controls['login_email'].setValue("", {onlySelf: true});
        this.loginForm.controls['login_password'].setValue("", {onlySelf: true});
    }

    ngOnDestroy(): void {

        this.userLoggedEvent.unsubscribe();
        this.customerLoadedEvent.unsubscribe();
    }

    ngOnInit(): void {

        if (this.registry.customer != null) {
            this.customer = this.registry.customer;
            this.status = 'loggedin';
        }

    }

    login() {

        let email = this.loginForm.value.login_email;
        let password = this.loginForm.value.login_password;
        this.removeSearchBarValue(null);
        if (email == "" || password == "") {
            return;
        }
        this.isLoggin = true;

        // this.authService.customerAuthentication(email, password).subscribe(token => {
        //
        //         //setup the user
        //         localStorage.setItem('customer_type', 'user');
        //         localStorage.setItem('t', String(token));
        //
        //         this.registry.setupCustomer().subscribe(success => {
        //
        //                 this.isLoggin = false;
        //             },
        //             failure => {
        //                 this.isLoggin = false;
        //             }
        //         )
        //
        //     },
        //     error => {
        //
        //        this.openSuccessSnackBar(error.error.message , "OK");
        //
        //         // alert(error.error.message);
        //         this.isLoggin = false;
        //     }
        // );

        const quoteId = this.registry.Quote_id;


        if (quoteId != undefined) {

            this.cartService.getGuestCart(quoteId,this.registry.getWebsiteId()).subscribe(cart => {
                this.cart = cart;
                // this.cart.cartType = "user";
                // localStorage.setItem('cart_items', JSON.stringify(this.cart));


                this.authService.customerAuthentication(email, password).subscribe(token => {

                        // setup the user
                        localStorage.setItem('customer_type', 'user');
                        localStorage.setItem('t', String(token));
                        this.googleService.eventEmitter("login", 'ecommerce', 'login', email);

                        this.registry.setupCustomer().subscribe(success => {
                                this.isLoggin = false;
                                this.authService.EmitUserLoggedIn(this.registry.customer);


                                // var guestCart = JSON.parse(localStorage.getItem("cart_items")); //get them back

                                let cartId = localStorage.getItem('cartId');


                                for (let i = 0; i < this.cart.items.length; i++) {

                                    this.cartService.addItemToCart(this.registry.cart, this.cart.items[i].sku, this.cart.items[i].qty).subscribe(resp => {
                                            //user
                                            this.cartService.getCustomerCart(this.registry.getWebsiteId()).subscribe(cart => {
                                                cart.cartType = 'user';
                                                cart.quoteId = cartId;
                                                this.registry.cart = cart;
                                                this.cartService.cart = cart;
                                                this.cartService.EmitCartUpdated(cart);
                                            });

                                        },
                                        error => {
                                            this.isLoggin = false;

                                        }
                                    );

                                }

                            },
                            error => {

                                this.openSuccessSnackBar(error.error.message, "OK");

                                // alert(error.error.message);
                                this.isLoggin = false;


                            }
                        );


                    },

                    error => {
                        this.openSuccessSnackBar(error.error.message, null);

                        this.isLoggin = false;
                    }
                );


            });
        } else {
            this.authService.customerAuthentication(email, password).subscribe(token => {

                    //setup the user
                    localStorage.setItem('customer_type', 'user');
                    localStorage.setItem('t', String(token));

                    this.registry.setupCustomer().subscribe(success => {

                            this.isLoggin = false;
                        },
                        failure => {
                            this.isLoggin = false;
                        }
                    )

                },
                error => {

                    this.openSuccessSnackBar(error.error.message, "OK");

                    // alert(error.error.message);
                    this.isLoggin = false;
                }
            );

        }


    }

    // Snackbar that opens with success background
    openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
            horizontalPosition: "right",
            panelClass: ['primary-snackbar'],
        });
    }

    removeSearchBarValue(event) {
        if (event != null) {
            event.preventDefault();
        }
        localStorage.setItem('searchKeyword', '');
    }


    logout() {

        localStorage.setItem('customer_type', null);
        localStorage.setItem('t', null);
        localStorage.setItem('cartId', null);
        this.removeSearchBarValue(null);

        this.isLogginout = true;
        this.registry.setupCustomer().subscribe(result => {

            this.registry.customer = null;
            this.customer = null
            this.isLogginout = false;
            this.authService.EmitUserLoggedOut();

        });

    }
}
